/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

module.exports = listCacheClear;



//////////////////
// WEBPACK FOOTER
// ./~/why-did-you-update/~/lodash/_listCacheClear.js
// module id = 739
// module chunks = 0